(function() {
    'use strict';

    angular
        .module('atheer.core')
        .directive('fpTooltip', fpTooltip);

    /* @ngInject */
    function fpTooltip($compile, $mdUtil, $interpolate, $timeout) {
        return {
            restrict: 'E',
            scope: {
                options: '<',
                placement: '@',
                class: '@'
            },
            link: function($scope, element, attrs) {
                var instance = null;
                var parent = element.parent();
                var defaultOptions = {
                    arrow: true,
                    delay: 100,
                    placement: 'bottom',
                    touch: false,
                    onShow: function (instance){
                        if($scope.class) {
                            instance.popper.classList.add($scope.class);
                        }
                        instance.setContent($interpolate(element.text())($scope));
                    }
                };

                if ($scope.placement) {
                    defaultOptions.placement = $scope.placement;
                } else {
                    defaultOptions.placement = 'bottom'
                };

                $scope.$watch('options', function(options) {
                    var tippyOptions = defaultOptions;

                    if (options) {
                        angular.merge(tippyOptions, defaultOptions, options);
                    }

                    var id = parent.attr('id');
                    if (id == undefined || id == null || id.length <= 0) {
                        id = 'id-' + $mdUtil.nextUid();
                        parent.attr("id", id);
                    };

                    $timeout(function() {
                        tippyOptions.content = $interpolate(element.text())($scope);
                        instance = tippy('#' + id, tippyOptions);
                        element.remove();
                    }, 0);
                });
                $scope.$on('$destroy', function() {
                    if(instance && instance.length) {
                        instance[0].destroy();
                        element.remove();
                    }
                });
            }
        };
    }
})();
